import type { Board } from "../../board";
import { PRIORITY_DEFAULT, type ProcessableThing } from "../../interfaces";
import { PhysicalThing } from "../../physicalThing";
import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";

export class PlayerOnTileAction extends PhysicalThing implements ProcessableThing {
	static key = "PlayerOnTileAction";
	private action: () => void;

	constructor(xy: XY, action: () => void = () => {}) {
		super(xy, false);
		this.action = action;
	}

	processTurn(board: Board): void {
		if (board.player && board.player.xy.equals(this.xy)) {
			this.action();
			board.removeAtEndOfTurn(this);
		}
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	getZOrder(): number {
		return 0;
	}

	isVisible(): boolean {
		return false;
	}

	static deserialize(data: any): PlayerOnTileAction {
		const p = new PlayerOnTileAction(deserializeXY(data.xy));
		p.visualId = data.visualId;
		return p;
	}
}
